import type { TMemberReportsListParams } from 'app/queries/organizations/organizationsKeys';

export const buildOrgMemberReportsRequest = (organizationId: string, params: TMemberReportsListParams) => ({
  oid: organizationId,
  pageNo: params.page.toString(),
  pageSize: params.pageSize.toString(),
  orderBy: params.orderBy,
  orderType: params.orderType,
  search: params.search,
  jobsFrom: params.jobsFrom,
  jobsTo: params.jobsTo,
});
